export const CELL_PROPS = {
  item: {
    type: Object,
    default: () => ({})
  },
  selectedKey: String,
  value: Array,
  showCheckbox: {
    type: Boolean,
    default: false
  },
  handleChangeCheckbox: Function,
  handleEvent: Function,
  type: String,
  resizeCellHeight: Function,
  selectMode: String, // 单选的模式 none 无 single 单选  multiple 多选
  draggable: {
    type: Boolean,
    default: true
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/props/cell.js